import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Automation } from "../../models/Automation";
import { fetchAutomations, fetchAutomationById, updateAutomation, createAutomation, assingFollowUpMessage, deleteFollowUpMessage, updateFollowUpMessage, createFollowUpMessage, fetchFollowUps, needToLoadClientAutomation, fetchClientAutomations, deleteFollowUpMessageExcecution, fetchLeadAutomations } from "./action";
import { ClientLeadFrequencyAutomation, FrequencyFormModel } from "../../models/FollowUp";

interface AutomationState {
  automations: Automation[],
  isLoading: boolean,
  error: string | null,
  currentAutomation?: any,
  followUpMessages: FrequencyFormModel[],
  isLoadingFollowUpMessages: boolean,
  errorFollowUpMessages: string | null,
  clientAutomations: ClientLeadFrequencyAutomation[],
  leadAutomations: ClientLeadFrequencyAutomation[],
  isLoadingClientLeadAutomations: boolean,
  errorClientLeadAutomations: string | null,
  needToLoadClientAutomations: boolean
}

const initialState: AutomationState = {
  automations: [],
  isLoading: false,
  error: null,
  followUpMessages: [],
  isLoadingFollowUpMessages: false,
  errorFollowUpMessages: null,
  
  clientAutomations: [],
  leadAutomations: [],
  isLoadingClientLeadAutomations: false,
  errorClientLeadAutomations: null,
  needToLoadClientAutomations: true
}

// slice
const automationSlice = createSlice({
  name: "automations",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAutomations.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(fetchAutomations.fulfilled, (state, action: PayloadAction<Automation[]>) => {
        state.isLoading = false;
        state.automations = action.payload;
      })
      .addCase(fetchAutomations.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAutomationById.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(fetchAutomationById.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.isLoading = false;
        state.currentAutomation = action.payload;
      })
      .addCase(fetchAutomationById.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateAutomation.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(updateAutomation.fulfilled, (state, action: PayloadAction<any>) => {
        const updatedAutomation = action.payload;
        const updatedAutomations = state.automations.map((automation) => {
          return automation.id === updatedAutomation.id ? updatedAutomation : automation
        }
        );
        state.automations = updatedAutomations;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateAutomation.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createAutomation.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(createAutomation.fulfilled, (state, action: PayloadAction<any>) => {
        state.automations = state.automations.concat(action.payload);
        state.isLoading = false;
        state.error = null;
      })
      .addCase(createAutomation.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchFollowUps.pending, (state) => {
        state.isLoadingFollowUpMessages = true;
        state.errorFollowUpMessages = null
      })
      .addCase(fetchFollowUps.fulfilled, (state, action: PayloadAction<FrequencyFormModel[]>) => {
        state.isLoadingFollowUpMessages = false;
        state.followUpMessages = action.payload;
      })
      .addCase(fetchFollowUps.rejected, (state, action: any) => {
        state.isLoadingFollowUpMessages = false;
        state.errorFollowUpMessages = action.payload;
      })
      .addCase(createFollowUpMessage.pending, (state) => {
        state.isLoadingFollowUpMessages = true;
        state.errorFollowUpMessages = null
      })
      .addCase(createFollowUpMessage.fulfilled, (state, action: PayloadAction<FrequencyFormModel>) => {
        state.followUpMessages = state.followUpMessages.concat(action.payload);
        state.isLoadingFollowUpMessages = false;
        state.errorFollowUpMessages = null;
      })
      .addCase(createFollowUpMessage.rejected, (state, action: any) => {
        state.isLoadingFollowUpMessages = false;
        state.errorFollowUpMessages = action.payload;
      })
      .addCase(updateFollowUpMessage.pending, (state) => {
        state.isLoadingFollowUpMessages = true;
        state.errorFollowUpMessages = null
      })
      .addCase(updateFollowUpMessage.fulfilled, (state, action: PayloadAction<FrequencyFormModel>) => {
        state.isLoadingFollowUpMessages = false;
        const updatedFollowUp = action.payload;
        const updatedFollowUps = state.followUpMessages.map((follow) => {
                return follow.id === updatedFollowUp.id ? updatedFollowUp : follow
            }
        );
        state.followUpMessages = updatedFollowUps;
      })
      .addCase(updateFollowUpMessage.rejected, (state, action: any) => {
        state.isLoadingFollowUpMessages = false;
        state.errorFollowUpMessages = action.payload;
      })
      .addCase(deleteFollowUpMessage.pending, (state) => {
        state.isLoadingFollowUpMessages = true;
        state.errorFollowUpMessages = null
      })
      .addCase(deleteFollowUpMessage.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoadingFollowUpMessages = false;

        const followUps = state.followUpMessages
        const index = followUps.findIndex((f) => f.id === action.payload.followUpId)

        if(index !== -1) {
              followUps.splice(index, 1)
              state.followUpMessages = followUps
        }
      })
      .addCase(deleteFollowUpMessage.rejected, (state, action: any) => {
        state.isLoadingFollowUpMessages = false;
        state.errorFollowUpMessages = action.payload;
      })
      .addCase(assingFollowUpMessage.pending, (state) => {
        state.isLoadingFollowUpMessages = true;
        state.errorFollowUpMessages = null
      })
      .addCase(assingFollowUpMessage.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoadingFollowUpMessages = false;
      })
      .addCase(assingFollowUpMessage.rejected, (state, action: any) => {
        state.isLoadingFollowUpMessages = false;
        state.errorFollowUpMessages = action.payload;
      })
      .addCase(fetchClientAutomations.pending, (state) => {
        state.isLoadingClientLeadAutomations = true;
        state.errorClientLeadAutomations = null
      })
      .addCase(fetchClientAutomations.fulfilled, (state, action: PayloadAction<ClientLeadFrequencyAutomation[]>) => {
        state.isLoadingClientLeadAutomations = false;
        state.clientAutomations = action.payload;
      })
      .addCase(fetchClientAutomations.rejected, (state, action: any) => {
        state.isLoadingClientLeadAutomations = false;
        state.errorClientLeadAutomations = action.payload;
      })
      .addCase(needToLoadClientAutomation.fulfilled, (state, action: PayloadAction<boolean>) => {
        state.needToLoadClientAutomations = action.payload;
        if(action.payload) {
          state.clientAutomations = [];
        }
      })
      .addCase(fetchLeadAutomations.pending, (state) => {
        state.isLoadingClientLeadAutomations = true;
        state.errorClientLeadAutomations = null
      })
      .addCase(fetchLeadAutomations.fulfilled, (state, action: PayloadAction<ClientLeadFrequencyAutomation[]>) => {
        state.isLoadingClientLeadAutomations = false;
        state.leadAutomations = action.payload;
      })
      .addCase(fetchLeadAutomations.rejected, (state, action: any) => {
        state.isLoadingClientLeadAutomations = false;
        state.errorClientLeadAutomations = action.payload;
      })
      .addCase(deleteFollowUpMessageExcecution.pending, (state) => {
        state.isLoadingClientLeadAutomations = true;
        state.errorClientLeadAutomations = null
      })
      .addCase(deleteFollowUpMessageExcecution.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoadingClientLeadAutomations = false;

        if(action.payload.isClient) {
          const cAutomations = state.clientAutomations
          const index = cAutomations.findIndex((a) => a.id === action.payload.automationId)
  
          if(index !== -1) {
            cAutomations.splice(index, 1)
            state.clientAutomations = cAutomations
          }
        } else {
          const lAutomations = state.leadAutomations
          const index = lAutomations.findIndex((a) => a.id === action.payload.automationId)
  
          if(index !== -1) {
            lAutomations.splice(index, 1)
            state.leadAutomations = lAutomations
          }
        }
      })
      .addCase(deleteFollowUpMessageExcecution.rejected, (state, action: any) => {
        state.isLoadingClientLeadAutomations = false;
        state.errorClientLeadAutomations = action.payload;
      });
  },
});

export default automationSlice.reducer;